<template>
  <div class="container flex">
    <!-- <div class="container-list"> -->
    <div class="ml20 mt20 f18 blue cursor" @click="$router.back()"><i class="el-icon-back"></i> 返回</div>
    <div class="f-right mt20">
      <div class="flex1 common-head-title">{{ basename }}报告</div>

      <!-- <div class="flex1"></div> -->

      <el-button icon="el-icon-plus" type="primary" style="margin-right: 20px" v-hasPermi="['wenwu:report:add']" @click="add">新增</el-button>
      <el-button style="margin-left: -10px; margin-right: 20px" type="primary" @click="fullScreen = true" v-if="this.url">弹窗显示</el-button>
    </div>

    <div id="test" class="flex ml10 mt10">
      <div class="leftnav mt10" style="width: 25%; height: 91%">
        <div style="width: 100%" class="center">
          <!-- <el-col :span="24">
            <el-input
              placeholder="请输入部位号或名称搜索"
              clearable
              v-model="rightParams.true_addr"
              prefix-icon="el-icon-search"
            ></el-input>
          </el-col> -->
          <!-- <el-col :span="5">
            <el-button
              type="primary"
              class="ml10"
              style="margin-top: 0px"
              size="small"
              @click="searchRight"
              >查询</el-button
            >
          </el-col> -->
          <!-- <el-col :span="5">
            <el-button
              class="ml10"
              style="margin-top: 0px"
              size="small"
              @click="reset"
              >重置</el-button
            >
          </el-col> -->
        </div>
        <div style="width: 100%; height: 90%; overflow: auto">
          <ul class="reportList cursor" v-if="list.length">
            <li v-for="(item, index) in list" :class="curIndex == index ? 'focus' : ''" @click="play(item, index)" style="justify-content: space-between">
              <div class="fl flex1 center">
                <span>{{ item.wj_name }}</span>
              </div>
              <div class="f-right">
                <el-button type="danger" style="margin-left: 20px" @click.stop="del(item)" size="mini" v-hasPermi="['wenwu:reportdetail:del']"> 删除</el-button>
                <el-button v-hasPermi="['wenwu:reportdetail:download']" type="success" @click.stop="down(item)" size="mini"> 下载</el-button>
              </div>
            </li>
          </ul>
          <div v-else style="width: 100%; color: #999" class="center mt10">
            暂无数据
          </div>
        </div>
        <el-pagination background layout="prev, pager, next" :page-size="10" @current-change="pageChange" :total="count"> </el-pagination>
      </div>
      <div class="content">
        <videoPlayer v-if="playtype == 1" style="height: 100%; width: 100%" ref="video"></videoPlayer>
        <div class="flex center" style="width: 100%; height: 100%" v-else-if="playtype !== 1">
          <!-- <img :src="url" v-if="playtype == 2" style="" alt="" /> -->
          <el-image v-if="playtype == 2" style="height: 100%" :src="url" :preview-src-list="[url]" />
          <iframe style="height: 100%; width: 100%" :src="url" v-else @click="fullScreen = true" frameborder="0"></iframe>
        </div>
      </div>
    </div>

    <el-dialog :before-close="beforeClose" :visible.sync="fullScreen" :width="'80%'" ref="model" :close-on-click-modal="false">
      <div class="content screenfull">
        <videoPlayer v-if="playtype == 1" style="height: 700px; width: 100%" ref="video"></videoPlayer>
        <div class="flex center" style="width: 100%; height: 700px" v-else-if="playtype !== 1">
          <img :src="url" v-if="playtype == 2" style="" alt="" />
          <iframe style="height: 700px; width: 100%" :src="url" v-else frameborder="0"></iframe>
        </div>
      </div>
    </el-dialog>
    <el-dialog :before-close="beforeClose" :visible.sync="showDia" :width="'830px'" ref="model" :close-on-click-modal="false">
      <el-row :gutter="30" v-loading="loading1">
        <el-col :span="13">
          <el-form :model="form" :rules="rules" ref="form" label-width="80px" size="small">
            <el-form-item label="单位名称" prop="basebg.bg_company_num">
              <el-select disabled v-model="form.basebg.bg_company_num" filterable remote placeholder="请输入关键词" :loading="sloading">
                <el-option v-for="item in compList" :key="item.c_company_num" :label="item.c_name" :value="item.c_company_num"></el-option>
              </el-select>
              <!-- <el-button size="mini" @click="addUnit">新增社会单位</el-button> -->
            </el-form-item>
            <el-form-item label="项目名称" v-if="false" prop="xiangmubg.xm_suoshu">
              <!-- <el-input v-model="form.xiangmubg.xm_suoshu"></el-input> -->

              <el-select disabled v-model="form.xiangmubg.xm_suoshu" filterable remote placeholder="请输入关键词" :loading="sloading">
                <el-option v-for="item in programList" :key="item.uuid" :label="item.name" :value="item.uuid"></el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="报告类型" prop="xiangmubg.xm_baogao_leixing">
              <el-select v-model="form.xiangmubg.xm_baogao_leixing" filterable clearable disabled>
                <el-option :label="item.mc_name" :value="item.mc_id" v-for="item in randomList"></el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="生成日期" prop="basebg.starttime">
              <el-date-picker v-model="form.basebg.starttime" type="datetime" placeholder="选择日期时间" disabled value-format="yyyy-MM-dd HH:mm:ss"> </el-date-picker>
            </el-form-item>
            <el-form-item label="检查人员" v-if="false" prop="xiangmubg.xm_jiancha_user">
              <!-- <el-input :value="tr_address" ></el-input>
               -->

              <!-- <el-select multiple="" v-model="form.tr_per">
                
               </el-select> -->
              <el-input disabled v-model="form.xiangmubg.xm_jiancha_user"> </el-input>
            </el-form-item>
            <el-form-item label="选择文件" prop="wenjianbg">
              <el-upload drag action="." :http-request="upload" multiple list-type="none" :before-upload="beforeUpload">
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">可上传pdf或word文件将文件拖到此处，或<em>点击上传</em></div>
              </el-upload>
            </el-form-item>
          </el-form>
        </el-col>
        <el-col :span="11">
          <el-card class="upload-box">
            <el-scrollbar style="height: 440px">
              <ul class="file-list">
                <li v-for="item in fileList" class="align-center">
                  <img src="@/assets/img/base.png" alt="" />
                  <div class="flex1">
                    <div class="mb5" :title="item.name">{{ item.name }}</div>
                    <div class="mb5">{{ (item.size / 1024 / 1024).toFixed(2) }}M</div>
                    <el-progress :percentage="+item.progress.toFixed(1)"></el-progress>
                  </div>
                  <i class="el-icon-close" @click="closeFile(item)"></i>
                </li>
              </ul>
            </el-scrollbar>
          </el-card>
        </el-col>
      </el-row>

      <!-- <el-form
        :model="editForm"
        :rules="rules1"
        ref="form1"
        label-width="80px"
        size="small"
        v-else
        v-loading="loading1"
      >
        <el-form-item label="单位名称">
          <el-input v-model="tr_address" disabled></el-input>
        </el-form-item>
        <el-form-item label="项目名称" prop="tr_project_name">
          <el-select
            v-model="editForm.tr_project_name"
            filterable
            remote
            placeholder="请输入关键词"
            :remote-method="remoteMethod"
            @change="changeS"
            :loading="sloading"
          >
            <el-option
              v-for="item in projectList"
              :key="item.id"
              :label="item.unit_name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="报告名称">
          <el-input v-model="tr_address" disabled></el-input>
        </el-form-item>
        <el-form-item label="报告类型" prop="tr_undertaker">
          <el-select v-model="editForm.tr_undertaker">
            <el-option
              :label="item.tr_user_name"
              :value="item.tr_user_id"
              v-for="item in userList"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="报告生成日期" prop="tr_assist">
          <el-select v-model="editForm.tr_assist">
            <el-option
              :label="item.tr_user_name"
              :value="item.tr_user_id"
              v-for="item in userList"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form> -->

      <div class="center">
        <el-button type="primary" @click="formSubmit" size="small" :loading="isUpload">提交</el-button>
        <el-button
          @click="
            beforeClose(() => {
              showDia = false;
            })
          "
          size="small"
          >取消</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>
<script>
// import { AIMarker } from "vue-picture-bd-marker";
// import crtmarker from "../../components/crtmarker";
// import CusPlayer from "../../components/CusPlayer.vue";
import OSS from 'ali-oss';

import { getMapByid } from '../../api/common';
import 'xgplayer';
import FlvJsPlayer from 'xgplayer-flv.js';
import config from '../../utils/config.js';
import videoPlayer from '../../components/videoPlayr';

export default {
  components: {
    videoPlayer,
  },
  data() {
    return {
      form: {
        basebg: {
          bg_company_num: '',
          starttime: '',
        },
        xiangmubg: {
          xm_baogao_leixing: '',
          xm_suoshu: '',
          xm_jiancha_user: '',
        },
        wenjianbg: [],
      },
      wenjian: [],
      fileList: {},
      fileType: ['docx', 'doc', 'pdf'],
      fullScreen: false,
      compList: [], // 公报私
      programList: [], // 项目
      randomList: [],
      status: '',
      isread: false,
      isUpload: false,
      basename: '',
      loading1: false,
      sloading: false,
      showDia: false,
      num: 1,
      id: this.$route.query.id,
      rules: {
        'basebg.bg_company_num': [{ required: true, message: '请选择单位', trigger: 'blur' }],
        'xiangmubg.xm_suoshu': [{ required: true, message: '请选择所属项目', trigger: 'blur' }],
        wenjianbg: [{ required: true, message: '请上传图片', trigger: 'blur' }],
        'xiangmubg.xm_baogao_leixing': [{ required: true, message: '请选择类型', trigger: 'blur' }],

        'xiangmubg.xm_jiancha_user': [{ required: true, message: '请填写检查人员', trigger: 'blur' }],
        'basebg.starttime': [{ required: true, message: '请选择日期', trigger: 'blur' }],
      },
      params: {
        page: 1,
        xm_uuid: this.$route.query.id,
      },

      list: [{}], // 摄像头列表
      count: 0,
      curIndex: null,
      playtype: 0, // 1 视频 2图片 3 pdf
      url: '',
      playItem: {},
      playIndex: 0,
      onlineAndOffline: 0,
      //
    };
  },
  watch: {
    showDia() {},
    // isdraged(val){
    //   if(!val){
    //     // this.$message.warning('选择点位标注')
    //       this.setQuery('block')
    //   }else{
    //         this.getdwList()
    //     // this.$message.warning('退出点位标注')
    //       // this.setQuery('none')
    //   }
    // }
  },
  beforeDestroy() {
    this.$refs.video.open = false;
  },
  created() {
    this.onlineAndOffline = JSON.parse(localStorage.getItem('userInfo')).isOnline; //0为离线（内网），1为在线（外网）
    this.$post('/dzda/allxiangmu', this.params).then((res) => {
      this.programList = res.data;
    });
    // 查询报告类型
    this.$post('/devicemanage/mapcode', { mc_parent_id: 232 }).then((res) => {
      this.randomList = res.data;
    });
    this.$post('/dzda/allbase').then((res) => {
      this.compList = res.data;
    });
    this.getList();
    // 获取单位

    // this.clearPoint(1)
  },
  methods: {
    // 上传
    beforeUpload(file) {
      if (this.fileType) {
        let fileExtension = '';
        if (file.name.lastIndexOf('.') > -1) {
          fileExtension = file.name.slice(file.name.lastIndexOf('.') + 1);
        }
        fileExtension = fileExtension.toLowerCase();
        const isTypeOk = this.fileType.some((type) => {
          if (file.type.indexOf(type) > -1) return true;
          if (fileExtension && fileExtension.indexOf(type) > -1) return true;
          return false;
        });
        if (!isTypeOk) {
          this.$message.error(`文件格式不正确, 请上传${this.fileType.join('/')}格式文件!`);
          return false;
        }
      }
    },
    upload(val) {
      if (this.onlineAndOffline == 0) {
        if (
          !(
            val.file.name.indexOf('doc') > -1 ||
            val.file.name.indexOf('docx') > -1 ||
            val.file.name.indexOf('pdf') > -1 ||
            val.file.name.indexOf('jpg') > -1 ||
            val.file.name.indexOf('png') > -1 ||
            val.file.name.indexOf('jpeg') > -1
          )
        ) {
          this.$notify({
            title: '暂不支持该文件类型',
            // message: `${ .fileList[id].name}上传完成`,
            type: 'warning',
          });

          return;
        }
        let file = val.file;
        let id =
          // "/common/upload" +
          // // this.$config.dangan +
          // "/t" +
          Date.now() + 's' + file.size + '/' + file.name;
        this.$set(this.fileList, id, {
          name: file.name,
          size: file.size,
          uploading: true,
          time: 0,
          progress: 0,
          key: id,
          url: '',
          // client: client,
        });
        log(this.fileList, '111111111111111111111');

        let formData = new FormData();
        console.log(formData, 'formData');
        formData.append('file', file);
        console.log(formData, 'formData1');
        // formData.append("title", this.title);
        // this.getTimes(file, id);
        console.log(file, 'file');

        this.$post('/common/upload', formData).then((res) => {
          this.fileList[id].progress = 100;
          this.fileList[id].uploading = false;
          this.fileList[id].url = res.data.url;
          //   this.$set(this.fileList, id, {
          //   key: res.data.url,
          //   // client: client,
          // });

          // this.fileList.key=res.data.url
          this.$notify({
            title: '上传成功',
            message: `${this.fileList[id].name}上传完成`,
            type: 'success',
          });
        });
      } else {
        let client = new OSS(this.$store.state.config.ossConfig);
        let file = val.file;
        let _this = this;
        let id = this.$config.dangan + '/t' + Date.now() + 's' + file.size + '/' + file.name;
        this.$set(this.fileList, id, {
          name: file.name,
          size: file.size,
          uploading: true,
          time: 0,
          progress: 0,
          key: id,
          client: client,
        });
        // 定义上传方法。
        function multipartUpload() {
          _this.fileList[id].client
            .multipartUpload(id, file, {
              checkpoint: _this.fileList[id] ? _this.fileList[id].data : null,
              progress: (p, checkpoint, res) => {
                //log(p,checkpoint,res)
                if (checkpoint) {
                  _this.fileList[id].progress = p * 100;
                  _this.fileList[id].data = checkpoint;
                }
              },
              partSize: 1000 * 1024, //设置分片大小
              timeout: 120000, //设置超时时间
              mime: val.type,
            })
            .then((res) => {
              _this.fileList[id].progress = 100;
              _this.fileList[id].uploading = false;
              _this.$notify({
                title: '上传成功',
                message: `${_this.fileList[id].name}上传完成`,
                type: 'success',
              });
            })
            .catch((err) => {
              if (err.code == 'RequestError' || err.code == 'ConnectionTimeoutError') {
                //网络错误或超时
                setTimeout(multipartUpload, 3000);
              }
            });
        }

        multipartUpload();
      }
    },
    // 提交上传
    formSubmit() {
      if (this.onlineAndOffline == 0) {
        let _this = this;
        var arr = [];

        for (let key in this.fileList) {
          let data = this.fileList[key];
          console.log(data, key, 'data,key');
          arr.push({
            wj_name: data.name,
            wj_lujing: data.url,
          });
        }

        var obj = {
          xm_uuid: this.$route.query.id,
          wenjianbg: arr,
        };
        console.log(obj.wenjianbg.wj_lujing);

        this.playItem = arr[0];
        console.log(this.playItem, 'playItem');
        this.play(this.playItem, this.playIndex);
        if (obj.wenjianbg.length == 0) return this.$message.warning('请上传文件');
        this.$post('/dzda/addwenjian', obj).then((res) => {
          if (res.code == 200) this.$message.success(res.msg || '操作成功');
          this.showDia = false;
          this.cancleUpload();
          this.getList();
        });
      } else {
        let _this = this;
        var arr = [];
        for (let key in this.fileList) {
          let data = this.fileList[key];
          arr.push({
            wj_name: data.name,
            wj_lujing: key,
          });
        }

        var obj = {
          xm_uuid: this.$route.query.id,
          wenjianbg: arr,
        };
        console.log(obj.wenjianbg);
        if (obj.wenjianbg.length == 0) return this.$message.warning('请上传文件');
        this.$post('/dzda/addwenjian', obj).then((res) => {
          if (res.code == 200) this.$message.success(res.msg || '操作成功');
          this.showDia = false;
          this.cancleUpload();
          this.getList();
        });
      }
    },

    cancleUpload() {
      this.fileList = {};
      this.form = {
        basebg: {
          bg_company_num: '',
        },
        xiangmubg: {
          xm_baogao_name: '',
          xm_baogao_leixing: '',
          xm_suoshu: '',
          xm_jiancha_user: '',
        },
        wenjianbg: [],
      };
    },
    beforeClose(done) {
      if (this.isUpload) {
        this.$confirm('文件上传中，关闭将取消上传，是否取消', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(() => {
            done();
            this.cancleUpload();
          })
          .catch(() => {});
      } else {
        done();
      }
    },
    del(it) {
      this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true,
      })
        .then(() => {
          this.$post('/dzda/delwjbg', {
            wj_uuid: it.wj_uuid,
          }).then((re) => {
            if (re.code == 200) {
              // this.$message.success(re.msg || '操作成功');
              this.$message({
                message: re.msg || '操作成功',
                type: 'success',
                duration: 700,
              });
              this.getList();
              this.url = '';
            }
          });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除',
          });
        });
    },
    getList() {
      this.$post('/dzda/detailwj', this.params).then((res) => {
        console.log(res, 111111);
        this.list = res.list;
        this.basename = res.basename;
        this.play(res.list[0], this.playIndex);
      });
    },
    pageChange(val) {
      // console.log(val)
      this.params.page = val;
      this.getList();
    },
    // 报告新增

    add() {
      // if(this.form.wenjianbg == []){
      //   return this.$message.error('请上传文件')
      // }
      // else
      this.$post('/dzda/detailxmbg', { xm_uuid: this.$route.query.id }).then((res) => {
        var form = {
          basebg: {
            bg_company_num: res.data.bg_company_num,
            starttime: res.data.xm_baogao_time,
          },
          xiangmubg: {
            xm_baogao_leixing: Number(res.data.xm_baogao_leixing),
            xm_suoshu: res.data.xm_suoshu,
            xm_jiancha_user: res.data.xm_jiancha_user,
          },
          wenjianbg: [],
        };
        this.form = form;
      });
      this.showDia = true;
    },
    reset() {
      this.rightParams.number = '';
      this.rightParams.true_addr = '';
      this.getList();
    },
    play(item, index) {
      if (this.onlineAndOffline == 0) {
        console.log('离线');
        this.playItem = item;
        this.playIndex = index;
        console.log(item, index);
        this.curIndex = index;
        this.$get('/common/download/resource', {
          url: item.wj_lujing,
          // responseType: "blob",  wj_lujing
          // headers: {
          //   "type": 'application/pdf'
          // },
        }).then((res) => {
          var name = item.wj_lujing.indexOf('.') > -1 ? item.wj_lujing : item.name;
          var type = '';
          let client = new OSS(this.$store.state.config.ossConfig);

          this.url = client.signatureUrl(item.wj_lujing);

          if (/^.*\..*$/.test(name)) {
            type = name.split('.')[name.split('.').length - 1];
          }
          type = type.toUpperCase();

          if (this.$store.state.videoType.indexOf(type) > -1) {
            this.playtype = 1;
            setTimeout(() => {
              this.$refs.video.open = true;
              this.$refs.video.getDownUrl(item.wj_lujing, null, type, item.tr_length || '');
            }, 1);
          } else if (this.$store.state.pictureType.indexOf(type) > -1) {
            this.playtype = 2;
            this.$refs.video.open = false;
          } else if (type == 'PDF') {
            this.playtype = 3;

            const pdfBase64 = res;
            const arrayBuffer = Uint8Array.from(atob(pdfBase64), (c) => c.charCodeAt(0)).buffer;
            const blob = new Blob([arrayBuffer], { type: 'application/pdf' });
            const url = URL.createObjectURL(blob);
            console.log(url, 'url');
            this.url = url;

            this.$refs.video.open = false;
          } else if (type.toLowerCase().indexOf('doc') > -1) {
            this.playtype = 3;
            console.log('出发了吗');
            // const blob = new Blob([res], { type: 'application/pdf' }
            // base64;
            const pdfBase64 = res;
            const arrayBuffer = Uint8Array.from(atob(pdfBase64), (c) => c.charCodeAt(0)).buffer;
            const blob = new Blob([arrayBuffer], { type: 'application/pdf' });
            const url = URL.createObjectURL(blob);
            console.log(url, 'url');
            this.url = url;
          }
        });
      } else {
        console.log('在线');
        this.curIndex = index;
        var name = item.wj_lujing.indexOf('.') > -1 ? item.wj_lujing : item.name;
        var type = '';
        let client = new OSS(this.$store.state.config.ossConfig);
        this.url = client.signatureUrl(item.wj_lujing);

        console.log(item.wj_lujing, 5555555555555555);
        if (/^.*\..*$/.test(name)) {
          type = name.split('.')[name.split('.').length - 1];
        }
        type = type.toUpperCase();

        if (this.$store.state.videoType.indexOf(type) > -1) {
          this.playtype = 1;
          setTimeout(() => {
            this.$refs.video.open = true;
            this.$refs.video.getDownUrl(item.wj_lujing, null, type, item.tr_length || '');
          }, 1);
        } else if (this.$store.state.pictureType.indexOf(type) > -1) {
          this.playtype = 2;
          this.$refs.video.open = false;
        } else if (type == 'PDF') {
          this.playtype = 3;
          this.$refs.video.open = false;
        } else if (type.toLowerCase().indexOf('doc') > -1) {
          console.log(this.url, '11111111');
          var url = `https://view.officeapps.live.com/op/view.aspx?src=${encodeURIComponent(this.url)}`;
          this.url = url;
          // console.log(this.url, '22222222222');
        }
      }
    },
    down(it) {
      if (this.onlineAndOffline == 0) {
        download(it.wj_lujing, it.wj_name);
      } else {
        let client = new OSS(this.$store.state.config.ossConfig);
        var url = client.signatureUrl(it.wj_lujing);
        download(url, it.wj_name);
      }
    },
    // 搜素单位

    //提交
    submit() {
      // return
      // if(this.form.point_uuid){
      //   var obj = {
      //     point_uuid:this.form.point_uuid,
      //     x_axis:this.form.position.x,
      //     xa_axis:this.form.position.x1,
      //     y_axis:this.form.position.y,
      //     ya_axis:this.form.position.y1
      //     }`
      //     this.$post('crt/crtupdatedot',obj).then(res=>{
      //       this.$message.success('标点成功')
      //       this.form={}
      //       this.isdraged = !this.isdraged
      //       this.selectPoint=false
      //     })
      // }else{
      //   this.isdraged = !this.isdraged
      // }
    },
  },
  watch: {
    showDia(val) {
      if (!val) {
        this.cancleUpload();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.file-list {
  li {
    position: relative;
    padding: 20px 10px;
    border-bottom: 1px solid #eee;

    img {
      width: 75px;
      margin-right: 15px;
    }

    .el-icon-close {
      position: absolute;
      right: 20px;
      top: 8px;
      cursor: pointer;
    }
  }
}

.mb5 {
  margin-bottom: 5px;
}
.screenfull {
  min-height: 800px;
}
.ml20 {
  margin-left: 20px;
}
.mt10 {
  margin-top: 10px !important;
}
.selectVideo {
  border: solid 2px red;
  height: 500px;
  width: 600px;
  position: relative;
}
.focus {
  background: #3d62de;
  color: #fff;
}
.reportList {
  width: 99%;
  height: 100%;
  li {
    width: 100%;
    padding: 10px;
    display: flex;
    justify-content: center;
    border-bottom: 1px solid #c1c1c1;
  }
}
::v-deep .selected {
  z-index: 99999;
}
::v-deep .g-image-op {
  background: #fff;
  border: 1px solid #ccc;
  bottom: 110%;
  display: none;
}
::v-deep .g-image-op-del {
  display: none;
}
::v-deep .g-image-op-content {
  height: auto;
}
::v-deep .annotation {
  background: #000;
  border: none;
  /* animation: dianmove 0.5s infinite; */
  border-radius: 50%;
  /* border: none; */
}

.canvas {
  display: flex;
  align-items: center;
}
.container {
  height: 90%;
  width: 100%;
  flex-direction: column;
  .topnav {
    height: 20%;
  }
  .leftNav {
    height: 100%;
    max-width: 23%;
  }
  #test {
    border-top: 1px solid #ddd;

    height: 100%;
    .el-dialog__body {
      padding: 10px 20px !important;
    }
    .content {
      width: 74%;
      height: 100%;
      background: #000;
      display: flex;
      align-items: center;
      overflow: hidden;
      position: relative;
      border: 1px solid gray;
    }
  }
}
</style>
